module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title"
    }],
    staticClass: "body-container",
    attrs: {
      "id": "login",
      "data-title": _vm.$t('titleText.account_CZUR')
    }
  }, [_c('basicheader', {
    attrs: {
      "login": false
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "lang": _vm.lang
    }
  }), _vm._v(" "), _c('czurfooter', {
    on: {
      "changeAppLocale": _vm.changeAppLocale
    }
  }), _vm._v(" "), (_vm.lang === 'en' && _vm.showCookie) ? _c('div', [(_vm.isPhone && _vm.lang) ? _c('mobileCookie') : _c('cookie')], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b45d8a6e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b45d8a6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/index/index.vue
// module id = 440
// module chunks = 2